import {Init} from '@/core/Init'
import {Dimension, Point, Rect} from '@/core/main/Interface'
import {APP_EVT, APP_ROLE, SERIES_ID} from '@/core/config/constants'

import * as svgjs from '@svgdotjs/svg.js'


class Manipulate {

    public _stage: svgjs.Container

    constructor() {

        this._stage = Init.svg_stage

        Init.emitter.on(APP_EVT.SCALE_DESIGN, this.scaleDesign)
        Init.emitter.on(APP_EVT.MOVE_DESIGN, this.moveDesign)
        Init.emitter.on(APP_EVT.ROTATE_DESIGN, this.rotateDesign)
        Init.emitter.on(APP_EVT.FLIP_DESIGN, this.flipDesign)
        Init.emitter.on(APP_EVT.GET_DIMENSIONS, this.getDimensions)

    }


    /**
     *
     * @param {number} x
     * @param {number} y
     */
    moveDesign = (x: number, y: number): void => {

        for (let item of Init.set_design.items.values()) {

            let loc: svgjs.Matrix = item.ctm;

            item.setMatrix(
                loc.a,
                loc.b,
                loc.c,
                loc.d,
                loc.e += x,
                loc.f += y);

        }
    };


    /**
     * flip the set side-to-side, or top-to-bottom
     *
     * @param which
     */
    flipDesign = (which: string): void => {

        let base: { x: number, y: number } = this.getCenterpoint()

        let nX: number
        let nY: number

        for (let item of Init.set_design.items.values()) {

            let loc: svgjs.Matrix = item.ctm

            if (which == 'across') {

                nX = base.x - (loc.e - base.x)
                nY = loc.f
                loc.b = -loc.b
                loc.c = -loc.c

            } else {

                nX = loc.e
                nY = base.y - (loc.f - base.y)
                loc.a = -loc.a
                loc.d = -loc.d

            }

            item.setMatrix(
                loc.a,
                loc.b,
                loc.c,
                loc.d,
                nX,
                nY)

            item.rotateLabel()

        }

        Init.emitter.emit(APP_EVT.POST_FLIP_ADJUSTMENTS, which)

        Init.emitter.emit(APP_EVT.DESIGN_CHANGED)
    };


    /**
     *
     * @returns {{w: number, d: number}}
     */
    getDimensions = (svg: svgjs.Container): Dimension => {

        $('.no-size').hide();
        $('.ybox').hide();

        let b: svgjs.Box = svg.bbox();
        //let b: svgjs.Box = this._stage.bbox();
        let w: number;
        let d: number;
        let multiplier: number;

        switch (Init.series_id) {
            case SERIES_ID.RESIDENTIAL_INDOOR:
            case SERIES_ID.COMMERCIAL_2ANDOVER:
            case SERIES_ID.COMMERCIAL_INDOOR_UNDER2:
            case SERIES_ID.COMMERCIAL_OUTDOOR_UNDER2:
                multiplier = 2;
                break;

            case SERIES_ID.RUSTIC:
                // these SVG are drawn to Metric scale rather than the "inches x 2" dimensions of the original design tool
                multiplier = 30;
                break;

            default:
                multiplier = 24;
                break;
        }


        w = Math.round((b.width / multiplier) / Init.design_scale);
        d = Math.round((b.height / multiplier) / Init.design_scale);

        $('.no-size').show();

        return {w: w, d: d};

    };


    getDesignHeight = (): number => {

        let height: number = 0

        for (let item of Init.set_design.items.values()) {

            //console.log(item.itemName, item.peakHeight)
            height = Math.max(height, item.peakHeight)

        }

        return height
    };


    /**
     *
     * @returns {{w: number, d: number}}
     */
    getUseZoneSize = (series_id: number): number => {

        let zone: number;

        switch (series_id) {
            case SERIES_ID.RESIDENTIAL_INDOOR:
                zone = 24;
                break;

            case SERIES_ID.COMMERCIAL_OUTDOOR_UNDER2:
                zone = 36;
                break;

            case SERIES_ID.COMMERCIAL_INDOOR_UNDER2:
            case SERIES_ID.COMMERCIAL_2ANDOVER:
                zone = 72;
                break;

            default:
                zone = 12;
                break;
        }

        return zone

    };


    /**
     *
     * move the design to the center of the design area to allow
     * for screen resizing and various monitor dimensions
     */
    public autoCenterDesign(): void {

        let bbox: svgjs.Box = Init.svg_stage.bbox();
        //let bbox: svgjs.Box = this._stage.bbox();

        // leave some room around the edge of the design
        let padding: number;
        let adjust_w: number;

        let pad_adj: number = (Init.is_touch_device === true) ? 1 : 10;

        switch (Init.app_role) {
            case APP_ROLE.DESIGN:
            case APP_ROLE.LIBRARY:
                padding = 20 * pad_adj;
                adjust_w = 44 * pad_adj;
                break;

            case APP_ROLE.THUMB:
                padding = 4;
                adjust_w = 0;
                break;

            case APP_ROLE.PREVIEW:
                padding = 20 * pad_adj;
                adjust_w = 44 * pad_adj;
                break;

        }

        if ($('#sidebar').css('display') == 'none') {

            adjust_w = 20;
        }


        // get the center point of the design layer, and screen dimensions
        let design_center: Point = {x: Math.round(bbox.cx), y: Math.round(bbox.cy)};
        let screen_size: Rect = {w: $('#design-frame').innerWidth(), h: $('#design-frame').innerHeight()};


        // calculate what scale the set design could be to fill the screen
        let scale_x: number = ((screen_size.w - padding) - adjust_w) / Math.ceil(bbox.w);
        let scale_y: number = (screen_size.h - padding) / Math.ceil(bbox.h);

        // locate the distance the design is from the center of the design area
        let new_x: number = ((screen_size.w + (adjust_w - 20)) / 2) - design_center.x;
        let new_y: number = ((screen_size.h) / 2) - design_center.y;

        // select the new scale based on the shortest Xor Y scale
        let new_scale: number = Math.min(scale_x, scale_y);

        if ((new_scale * Init.design_scale) > 3) {

            new_scale = 3 / Init.design_scale;

        }

        //console.log( Init.design_scale, new_scale, new_scale * ((new_scale * Init.design_scale * 10) / 10));
        // set the new application scale, rounding it to the nearest one decimal place
        // do NOT use Math.round here, it will result in the saved design not scaling
        // correctly when it is retrieved!
        this.setGlobalScale((new_scale * Init.design_scale * 10) / 10);

        let grid: svgjs.Element = svgjs.SVG('#'+Init.grid_svg);

        grid.matrix(
            Init.design_scale,
            0,
            0,
            Init.design_scale,
            design_center.x,
            design_center.y);

        // then scale and move each of our items
        for (let item of Init.set_design.items.values()) {

            //console.log(item);

            let loc: svgjs.Matrix = item.ctm;

            item.setMatrix(
                loc.a * new_scale,
                loc.b * new_scale,
                loc.c * new_scale,
                loc.d * new_scale,
                design_center.x + ((loc.e - design_center.x) * new_scale) + new_x,
                design_center.y + ((loc.f - design_center.y) * new_scale) + new_y);

        }
    };


    /**
     *
     * move the design to the center of the design area to allow
     * for screen resizing and various monitor dimensions
     */
    printDesign = (): void => {

        let bbox: svgjs.Box = this._stage.bbox();

        // then scale and move each of our items
        for (let item of Init.set_design.items.values()) {

            let loc: svgjs.Matrix = item.ctm;

            item.setMatrix(
                loc.a,
                loc.b,
                loc.c,
                loc.d,
                loc.e - (bbox.x - 20),
                loc.f - (bbox.y - 20)
            )
        }

        $('#sidebar').hide();
        $('.header').hide();
        $('.svg-grid').hide();
        $('#svg-stage').addClass('print');
        $('body').removeClass('wrapper').addClass('print-body');

    };


    /**
     * used to find an xy centerpoint for the design.
     * This is used as the centerpoint for rotating and flipping the design.
     *
     * @returns {{x: number, y: number}}
     */
    getCenterpoint = (): Point => {

        let bbox: svgjs.Box = Init.svg_stage.bbox();
        //let bbox: svgjs.Box = this._stage.bbox();

        //console.log(bbox);

        return {x: Number(bbox.cx.toFixed(2)), y: Number(bbox.cy.toFixed(2))};

    };


    /**
     * this is the matrix for rotation by 90 degrees each time, clockwise:
     *   1  0  0  1    (0)
     *   0 -1  1  0    (90)
     *  -1  0  0 -1   (180)
     *   0  1 -1  0    (270)
     *
     * This function rotates the whole design by switching the X and Y locations
     * and rotating the individual items. This allows us to touch each item
     * and make adustments to labels, swing directions etc so that things
     * still look "normal" - eg: swings do not end up hanging "upwards".
     *
     * @param which
     */
    rotateDesign = (which: string): void => {

        let base: any = this.getCenterpoint();

        let nX: number;
        let nY: number;

        let newA: number;
        let newB: number;
        let newC: number;
        let newD: number;

        for (let item of Init.set_design.items.values()) {

            let loc: svgjs.Matrix = item.ctm;

            let diffX: number = loc.e - base.x;
            let diffY: number = loc.f - base.y;

            if (which == 'right') {

                nX = base.x + -diffY;
                nY = base.y + diffX;

                newA = -loc.b;
                newB = loc.a;
                newC = -loc.a;
                newD = loc.c;

            } else {

                nX = base.x + diffY;
                nY = base.y + -diffX;

                newA = loc.b;
                newB = -loc.a;
                newC = loc.a;
                newD = -loc.c;

            }

            item.setMatrix(
                newA,
                newB,
                newC,
                newD,
                nX,
                nY);

            //item.setState();
            //item.rotateLabel();

        }

        for (let item of Init.set_design.items.values()) {

            item.setState();
            //item.rotateLabel();

        }

        Init.emitter.emit(APP_EVT.ITEM_ROTATED);

    };


    /**
     * sets the design scale and adjusts the slider to reflect the new scale
     *
     * @param {number} scale
     */
    setGlobalScale = (scale: number): void => {

        scale = Number(scale.toFixed(2));

        Init.design_scale = scale;

        //console.trace(scale, String(scale * 10));

        //localStorage.setItem('design_scale', String(scale * 10));
        Init.setStorage('design_scale', String(scale * 10));

        $('#scale-slider').val(scale * 10);

    };


    /**
     * Scale all the items of a design so that the design can fit in the browser.
     * We do not just scale the SVG, as this can lead to issues with targeting groups.
     * This function loops around all items, calculates the new XY location
     * then scales and moves each item around the centerpoint of the design.
     *
     * @param scale
     */
    scaleDesign = (scale): void => {

        if (scale > 0 && scale <= 50) {

            let new_scale: number = scale / 10;
            let scaleRatio: number = (scale / (Init.design_scale * 10));

            //console.log(Init.design_scale, new_scale, scaleRatio, scale);

            this.setGlobalScale(new_scale);

            let center: Point = this.getCenterpoint();

            //console.log(new_scale, scaleRatio, Init.grid_svg);

            let grid: svgjs.Element = svgjs.SVG('#'+Init.grid_svg);

            grid.matrix(
                new_scale,
                0,
                0,
                new_scale,
                center.x,
                center.y);

            for (let item of Init.set_design.items.values()) {

                let loc: svgjs.Matrix = item.ctm;
                //console.log(((center.x + ((loc.e - center.x) * scaleRatio)).toFixed(2)),
                //	((center.y + ((loc.f - center.y) * scaleRatio)).toFixed(2)));
                item.setMatrix(
                    Number((loc.a * scaleRatio).toFixed(4)),
                    Number((loc.b * scaleRatio).toFixed(4)),
                    Number((loc.c * scaleRatio).toFixed(4)),
                    Number((loc.d * scaleRatio).toFixed(4)),
                    Number((center.x + ((loc.e - center.x) * scaleRatio)).toFixed(4)),
                    Number((center.y + ((loc.f - center.y) * scaleRatio)).toFixed(4))
                );

            }
        }
    }

}

export {Manipulate};

